import type React from "react";
import {
  PROPHETX_SIGNUP_CTA_AMOUNT,
  PROPHETX_SIGNUP_OFFER_DETAILS,
  PROPHETX_SIGNUP_OFFER_HEADLINE,
  PROPHETX_SIGNUP_PROMO_CODE,
  KALSHI_SIGNUP_CTA_AMOUNT,
  KALSHI_SIGNUP_OFFER_DETAILS,
  KALSHI_SIGNUP_OFFER_HEADLINE,
  KALSHI_SIGNUP_PROMO_CODE,
  DABBLE_SIGNUP_OFFER_DETAILS,
  DABBLE_SIGNUP_OFFER_HEADLINE,
  PARLAYPLAY_SIGNUP_OFFER_DETAILS,
  PARLAYPLAY_SIGNUP_OFFER_HEADLINE,
  PARLAYPLAY_SIGNUP_PROMO_CODE,
  NOVIG_SIGNUP_CTA_AMOUNT,
  NOVIG_SIGNUP_OFFER_DETAILS,
  NOVIG_SIGNUP_OFFER_HEADLINE,
  NOVIG_SIGNUP_PROMO_CODE,
  UNDERDOG_SIGNUP_OFFER_HEADLINE,
  UNDERDOG_SIGNUP_OFFER_DETAILS,
  UNDERDOG_SIGNUP_PROMO_CODE,
  UNDERDOG_SIGNUP_CTA_AMOUNT,
  FANDUEL_SIGNUP_OFFER_HEADLINE,
  FANDUEL_SIGNUP_OFFER_DETAILS,
  FANDUEL_SIGNUP_CTA_AMOUNT,
  REBET_SIGNUP_OFFER_HEADLINE,
  REBET_SIGNUP_OFFER_DETAILS,
  CHALKBOARD_SIGNUP_OFFER_HEADLINE,
  CHALKBOARD_SIGNUP_OFFER_DETAILS,
  CHALKBOARD_SIGNUP_PROMO_CODE,
  COURTSIDE_SIGNUP_OFFER_HEADLINE,
  COURTSIDE_SIGNUP_OFFER_DETAILS,
  COURTSIDE_SIGNUP_PROMO_CODE,
  SMACKTOK_SIGNUP_CTA_AMOUNT,
  SMACKTOK_SIGNUP_OFFER_DETAILS,
  SMACKTOK_SIGNUP_OFFER_HEADLINE,
  SMACKTOK_SIGNUP_PROMO_CODE,
  SPORTSBOOK_AFFILIATE_LINKS,
} from "@/lib/sportsbook-affiliate-links";
import { sportsbookLogoUrl } from "@/lib/sportsbook-logo-url";


export interface CPAOffer {
  id: string;
  name: string;
  headline: string;
  details: string;
  promoCode: string;
  link: string;
  logoSrc: string;
  brandColor: string;
  ctaAmount: string;
  weight: number;
  creative?: OfferCreative;
}

export interface OfferCreative {
  src: string;
  disclaimer: string;
}

export const CPA_OFFERS: CPAOffer[] = [
  {
    id: "novig",
    name: "NoVig",
    headline: NOVIG_SIGNUP_OFFER_HEADLINE,
    details: NOVIG_SIGNUP_OFFER_DETAILS,
    promoCode: NOVIG_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.novig,
    logoSrc: sportsbookLogoUrl("novig.png"),
    brandColor: "#79cfff",
    ctaAmount: NOVIG_SIGNUP_CTA_AMOUNT,
    weight: 20,
    creative: {
      src: "/images/promos/novig/deposit-10-get-50.webp",
      disclaimer:
        "RESTRICTIONS & REQUIREMENTS APPLY. NOT AVAILABLE IN ALL STATES. 21+. EVENT CONTRACT TRADING INVOLVES RISK & IS NOT APPROPRIATE FOR ALL. CONSIDER IF IT'S APPROPRIATE FOR YOU IN LIGHT OF FINANCIAL CIRCUMSTANCES. SEE NOVIG.COM/TERMS FOR INFORMATION.",
    },
  },
  {
    id: "prophetx",
    name: "ProphetX",
    headline: PROPHETX_SIGNUP_OFFER_HEADLINE,
    details: PROPHETX_SIGNUP_OFFER_DETAILS,
    promoCode: PROPHETX_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.prophetx,
    logoSrc: sportsbookLogoUrl("PX.png"),
    brandColor: "#0CA249",
    ctaAmount: PROPHETX_SIGNUP_CTA_AMOUNT,
    weight: 15,
  },
  {
    id: "kalshi",
    name: "Kalshi",
    headline: KALSHI_SIGNUP_OFFER_HEADLINE,
    details: KALSHI_SIGNUP_OFFER_DETAILS,
    promoCode: KALSHI_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.kalshi,
    logoSrc: sportsbookLogoUrl("kalshi.png"),
    brandColor: "#4DE4B2",
    ctaAmount: KALSHI_SIGNUP_CTA_AMOUNT,
    weight: 20,
  },
  {
    id: "underdog",
    name: "Underdog",
    headline: UNDERDOG_SIGNUP_OFFER_HEADLINE,
    details: UNDERDOG_SIGNUP_OFFER_DETAILS,
    promoCode: UNDERDOG_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.underdog,
    logoSrc: sportsbookLogoUrl("UD.webp"),
    brandColor: "#F4C542",
    ctaAmount: UNDERDOG_SIGNUP_CTA_AMOUNT,
    weight: 20,
  },
  {
    id: "fanduel",
    name: "FanDuel",
    headline: FANDUEL_SIGNUP_OFFER_HEADLINE,
    details: FANDUEL_SIGNUP_OFFER_DETAILS,
    promoCode: "",
    link: SPORTSBOOK_AFFILIATE_LINKS.fanduel,
    logoSrc: sportsbookLogoUrl("FD.png"),
    brandColor: "#38bdf8",
    ctaAmount: FANDUEL_SIGNUP_CTA_AMOUNT,
    weight: 20,
  },
  {
    id: "chalkboard",
    name: "Chalkboard",
    headline: CHALKBOARD_SIGNUP_OFFER_HEADLINE,
    details: CHALKBOARD_SIGNUP_OFFER_DETAILS,
    promoCode: CHALKBOARD_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.chalkboard,
    logoSrc: sportsbookLogoUrl("chalkboard.png"),
    brandColor: "#8B8FA3",
    ctaAmount: "$100",
    weight: 15,
  },
  {
    id: "courtside",
    name: "Courtside",
    headline: COURTSIDE_SIGNUP_OFFER_HEADLINE,
    details: COURTSIDE_SIGNUP_OFFER_DETAILS,
    promoCode: COURTSIDE_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.courtside,
    logoSrc: sportsbookLogoUrl("courtside.svg"),
    brandColor: "#FF4A00",
    ctaAmount: "$100",
    weight: 20,
  },
  {
    id: "rebet",
    name: "Rebet",
    headline: REBET_SIGNUP_OFFER_HEADLINE,
    details: REBET_SIGNUP_OFFER_DETAILS,
    promoCode: "",
    link: SPORTSBOOK_AFFILIATE_LINKS.rebet,
    logoSrc: sportsbookLogoUrl("RB.png"),
    brandColor: "#FF914D",
    ctaAmount: "$100",
    weight: 20,
  },
  {
    id: "dabble",
    name: "Dabble",
    headline: DABBLE_SIGNUP_OFFER_HEADLINE,
    details: DABBLE_SIGNUP_OFFER_DETAILS,
    promoCode: "",
    link: SPORTSBOOK_AFFILIATE_LINKS.dabble,
    logoSrc: sportsbookLogoUrl("DB.png"),
    brandColor: "#7742FF",
    ctaAmount: "$10",
    weight: 10,
  },
  {
    id: "parlayplay",
    name: "ParlayPlay",
    headline: PARLAYPLAY_SIGNUP_OFFER_HEADLINE,
    details: PARLAYPLAY_SIGNUP_OFFER_DETAILS,
    promoCode: PARLAYPLAY_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.parlayplay,
    logoSrc: sportsbookLogoUrl("parlay_play.png"),
    brandColor: "#f7c531",
    ctaAmount: "$100",
    weight: 10,
  },
  {
    id: "smacktok",
    name: "SmackTok",
    headline: SMACKTOK_SIGNUP_OFFER_HEADLINE,
    details: SMACKTOK_SIGNUP_OFFER_DETAILS,
    promoCode: SMACKTOK_SIGNUP_PROMO_CODE,
    link: SPORTSBOOK_AFFILIATE_LINKS.smacktok,
    logoSrc: sportsbookLogoUrl("smacktok.png"),
    brandColor: "#17F6A5",
    ctaAmount: SMACKTOK_SIGNUP_CTA_AMOUNT,
    weight: 15,
  },
];

export function handleImageError(event: React.SyntheticEvent<HTMLImageElement>) {
  const img = event.currentTarget;
  if (img.dataset.fallbackApplied === "true") return;
  img.dataset.fallbackApplied = "true";
  img.src = "/images/sportsbooks/upside_logo.png";
}

export function getEligibleOffers(
  offers: CPAOffer[],
  excludePlatformId: string | null
): CPAOffer[] {
  if (offers.length === 0) return offers;
  if (!excludePlatformId) return offers;
  const filtered = offers.filter((o) => o.id !== excludePlatformId);
  return filtered.length > 0 ? filtered : offers;
}

export function selectWeightedOffer(
  offers: CPAOffer[],
  excludePlatformId: string | null
): CPAOffer | null {
  if (offers.length === 0) return null;

  const pool = getEligibleOffers(offers, excludePlatformId);

  let totalWeight = 0;
  const cumulative: { offer: CPAOffer; cumWeight: number }[] = [];
  for (const offer of pool) {
    totalWeight += offer.weight;
    cumulative.push({ offer, cumWeight: totalWeight });
  }

  const roll = Math.random() * totalWeight;
  for (const entry of cumulative) {
    if (roll < entry.cumWeight) return entry.offer;
  }
  return pool[pool.length - 1];
}
